import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { AddressEntityEffects } from './addresses.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([AddressEntityEffects])]
})
export class AddressesEntityModule {}
